<sew-ws-content-wrapper>
    <div class="headline-tags-wrapper">
        <h2 class="typo-ws-h2" [innerHTML]="headline"></h2>
        <div class="tags-wrapper">
            @for (filteredTag of filteredTags; track filteredTag) {
                <div class="filtered-tag" (click)="filteredTagClicked(filteredTag)">
                    {{ filteredTag }}
                    <div class="tag-separator"></div>
                    <img _ngcontent-lmv-c107="" src="assets/images/tag_close.svg" />
                </div>
            }
        </div>
    </div>
    <div class="grid grid--six-columns">
        @for (blogPosts of filteredPosts; track blogPosts; let idx = $index) {
            <blog-post
                (postClicked)="postClick($event)"
                (tagClicked)="tagClick($event)"
                [post]="blogPosts"
                [size]="'m'"
                [ngClass]="getTeaserClass(idx)"
            ></blog-post>
        }
    </div>
</sew-ws-content-wrapper>
